// Per-visit flags for the assistant widget. Deliberately free of imports: the
// auth context reads them, and anything pulled in here would close a loop back
// through the api client.

// The launcher's unread dot has been seen.
export const CHAT_SEEN_KEY = "adm_chat_seen";

// The widget has already opened itself, or the user opened it first. Either way
// it should not open itself again this visit.
export const CHAT_AUTO_OPEN_KEY = "adm_chat_autoopened";

export function markChatOpened() {
  try {
    sessionStorage.setItem(CHAT_AUTO_OPEN_KEY, "1");
  } catch {
    /* private mode — the widget may greet twice, which is not worth guarding */
  }
}

export function chatAlreadyOpened() {
  try {
    return sessionStorage.getItem(CHAT_AUTO_OPEN_KEY) === "1";
  } catch {
    // Unreadable storage would mean opening on every page, so assume it has.
    return true;
  }
}

// A new sign-in is a new visit, even in a tab that already had one.
export function resetChatSession() {
  try {
    sessionStorage.removeItem(CHAT_AUTO_OPEN_KEY);
    sessionStorage.removeItem(CHAT_SEEN_KEY);
  } catch {
    /* nothing to reset */
  }
}
